import React from 'react';
import {
    Show, TabbedShowLayout, Tab, ReferenceField, NumberField,
    TextField, ImageField, FileField, FunctionField
} from 'react-admin'

export const NearbyShow = (props) => (
    <Show {...props}>
        <TabbedShowLayout>
            <Tab label="general">
                <ReferenceField linkType={false} label="Project name" source="project" reference="project">
                    <TextField source="name" />
                </ReferenceField>
                <TextField label='Area info name' source="name" />
                <NumberField source="rating" />
                <ImageField source="image.url" label='image' title="image.name" />
            </Tab>
            <Tab label="time">
                <FunctionField label="Open - Close"
                    render={record => `${record.time.open.hour}:${record.time.open.minute} - ${record.time.close.hour}:${record.time.close.minute}`} />
            </Tab>
            <Tab label='location'>
                <TextField label="Latitude" source="location[0]" />
                <TextField label="Longitude" source="location[1]" />
            </Tab>
        </TabbedShowLayout>
    </Show>
);


// WEBPACK FOOTER //
// ./src/components/nearby/NearbyShow.js